module.exports = __webpack_public_path__ + "mockups.png";